<template>
  <div>
    <div class="_1Qdk0RNOt0K2R6XUEiYwFb">
      <ul class="_1B5o52LzlcZjqtxgQL_0wT">
        <li>
          <div class="_130sYBNHWax9YtgUgIsm1Z" style="cursor: default;">
            <div class="container">
              <div class="container-l">
                <h1 style="text-align: left;font-weight: normal;">国家区块链创新应用试点</h1>
                <p style="font-size: 20px;font-family: 'PingFang-SC-Regular';">应用“区块链+版权”模式，融合区块链、人工智能、大数据等技术</p>
                <p style="text-align: left;">
                  <span>网络化</span>
                  <span>智能化</span>
                  <span>一体化</span>
                </p>
                <div style="text-align: left">
                  <button
                    type="button"
                    class="ant-btn ant-btn-primary ant-btn-lg"
                    style="margin-top: 40px"
                  >
                  <!-- <router-link to="/Register/InputForm">立即登记</router-link> -->
                  <!-- <a href="https://www.cnpkp.com/Home" target="_blank">了解更多</a> -->
                  <router-link :to="{path:'/Platform'}">了解更多</router-link>
                  </button>
                </div>
              </div>
              <img src="../assets/images/banner-img.png" alt="">
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="sliderWrap" style="display: none;">
          <slider ref="slider" :options="options">
              <!-- <slideritem class='slideritem2'>
                    <div class="container blockInner blockInner2">
                        <img class="img1 animate__animated animate__fadeInDown" src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/banner2.png">
                        <div class="animate__animated animate__fadeInDown">
                            <h2> 国家区块链创新应用试点 </h2>
                            <h4> 中国知链-基于区块链技术的学术论文知识产权<br>保护及认证体系平台 </h4>
                            <div class="btnWrap">  
                              <router-link :to="{path:'/ExistingEvidence/InputForm'}">
                                  <a-button size="large">去存证</a-button>
                              </router-link>
                            </div>
                        </div>
                    </div>
              </slideritem>
              <slideritem>
                    <div class="container blockInner">
                       <img class="img1 animate__animated animate__fadeInDown" src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/banner1.svg">
                        <div class="animate__animated animate__fadeInDown">
                            <h2> 基于区块链技术的知识产权保护 </h2>
                            <h4> 提供免费储存服务、拥有强大的内容服务体系 </h4>
                            <div class="btnWrap">  
                              <router-link :to="{path:'/ExistingEvidence/InputForm'}">
                                  <a-button size="large">存证原创</a-button>
                              </router-link>
                              <router-link :to="{path:'/Search'}">
                                    <a-button type="primary" size="large"> 搜索原创 </a-button>
                              </router-link>
                            </div>
                        </div>
                    </div>
              </slideritem> -->

              <slideritem>
                    <!-- <div class="container blockInner">
                       <img class="img1 animate__animated animate__fadeInDown" src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/home-banner01.png">
                        <div class="animate__animated animate__fadeInDown"> -->
                            <!-- <h2> 国家区块链<br>创新应用试点 </h2>
                            <h4> 中国知链-基于区块链技术的学术论文知识产权<br>保护及认证体系平台 </h4> -->
                            <!-- <img class="img2" src="https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/newBanner01.png" alt="">
                            <div class="btnWrap">
                              <router-link :to="{path:'/ExistingEvidence/InputForm'}">
                                  <a-button type="primary" size="large">存证原创</a-button>
                              </router-link>
                              <router-link :to="{path:'/Search'}">
                                    <a-button class="tosearch" size="large"> 搜索原创 </a-button>
                              </router-link>
                            </div>
                        </div>
                    </div> -->
              </slideritem>
              
              <div slot="loading">loading...</div>
          </slider>
    </div>
    <!-- <service-block></service-block>
    <superiority-block></superiority-block>
    <record-block></record-block>
    <guarantees-block></guarantees-block> -->
    
    <newHome></newHome>
  </div>
</template>

<script>

import ServiceBlock from '@/components/ServiceBlock'
import SuperiorityBlock from '@/components/SuperiorityBlock'
import GuaranteesBlock from '@/components/GuaranteesBlock'
import RecordBlock from '@/components/RecordBlock'
import { slider, slideritem } from 'vue-concise-slider'

import newHome from '@/components/newHome'

export default {
  name: 'Home',
  components: {
    ServiceBlock,
    SuperiorityBlock,
    GuaranteesBlock,
    RecordBlock,
    slider,
    slideritem,
    newHome
  },
  mounted () {
    this.init()
  },
  data () {
    return {
      //Slider configuration [obj]
      options: {
        currentPage: 0
      }
    }
  },
  methods: {
    init () {
      
    }
  }
}
</script>
<style lang="scss" scoped>
._1Qdk0RNOt0K2R6XUEiYwFb {
    height: 460px;
    position: relative;
    background-color: #999;
}
._1B5o52LzlcZjqtxgQL_0wT li {
    width: 100%;
    height: 460px;
    position: absolute;
    left: 0px;
    top: 0px;
    transition: all 1s;
}
._130sYBNHWax9YtgUgIsm1Z {
    height: 460px;
    background-color: #069;
    background-position: center center;
    // background-image: url('../assets/images/banner.jpg');
    background-image: linear-gradient(to right, #0A2F9B , #1550CA);
}
._130sYBNHWax9YtgUgIsm1Z .container{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}
._130sYBNHWax9YtgUgIsm1Z .container .container-l h1{
    font-size: 48px;
    // letter-spacing: 4px;
    color: #fff;
    padding-top: 40px;
    padding-bottom: 30px;
    text-align: center;
}
._130sYBNHWax9YtgUgIsm1Z .container .container-l p{
    font-size: 16px;
    color: #fafafa;
    line-height: 32px;
    text-align: center;
}
._130sYBNHWax9YtgUgIsm1Z .container .container-l p:nth-child(3) span{
  display: inline-block;
  border: 1px solid #fafafa;
  margin-right: 15px;
  padding: 0 12px;
  margin-top: 20px;
  font-size: 14px;
  line-height: 28px;
}
._130sYBNHWax9YtgUgIsm1Z .container .container-l div button{
  border-radius: 20px;
}
._130sYBNHWax9YtgUgIsm1Z .container .container-l div button a{
  text-decoration: none;
}
._130sYBNHWax9YtgUgIsm1Z .container img{
  height: 100%;
}
.sliderWrap{
  margin-top: -84px;
   background-size: 100%;
   height: 460px;
   /deep/ .slider-pagination-bullet{
     width:56px;
     display: inline-block;
     height: 4px;
     border-radius: 8px;
     background: rgba($color: #fff, $alpha: .20);
   }
  .slider-item{
    background: url('../assets/images/banner.jpg') no-repeat 50% 100%;
    background-position: center center;
    background-size: 100% 100%;
  }
  .slideritem2{
    background: url('https://ipchain.oss-cn-hangzhou.aliyuncs.com/web/privateicon/bannerBg2.png') no-repeat;
    background-size: 100%;
  }
   /deep/ .slider-pagination-bullet-active{
     background: rgba($color: #fff, $alpha: .65);
   }
   .blockInner{
     position: relative;
     display: flex;
     align-items: center;
     text-align: left;
      &>div:first-child{
        position: relative;
        z-index: 100;
      }
   }
   h2{
     font-size: 52px;
     color:rgba($color: #0071E7, $alpha: .9);
     font-weight: bold;
     text-shadow: 3px 3px 2px #77AAE0
   }
   h4{
     font-weight: 400;
     font-size: 20px;
     color:rgba($color: #04397F, $alpha: .65);
     margin-top:24px;
   }
   .btnWrap{
     margin-top:114px;
      .ant-btn{
        background: #007DFF;
        width: 180px;
        height: 44px;
        margin-right:24px;
        color: #ffffff;
      }
      .ant-btn.tosearch{
        background: transparent;
        border-color: #fff;
      }
   }
   .img1{
     position: absolute;
     top:-100px;
     width:460px;
     right:-200px;
   }
   .img2{
     width: 80%;
     max-width: 100%;
   }
}

@media (min-width: 1200px) {
  .sliderWrap{
    height:460px;
    .blockInner{
      h2{
        font-size: 48px;
      }
      h4{
        font-size: 22px;
      }
    }
    .img1{
      width: 460px;
    }
    .btnWrap{
      margin-top:114px;
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 1199px)  {
    .sliderWrap{
       height:auto;
      .blockInner{
        display: block;
        padding:24px 0 80px;
        margin-top: 84px;
        h2{font-size: 36px;}
        h4{font-size: 20px;    margin-top: 8px;}
      }
      .img1{
        width: 420px;
        position: absolute;
        margin-top:0;
        top: 20px;
      right: -140px;
      }
      .img3{
        width: 200px;
      }
      .btnWrap{
        margin-top:32px;
      }
    }
}

@media screen and (min-width: 10px) and (max-width: 767px) {
  .sliderWrap{
    height:auto;
    .slider-item{
    background-size: cover;
  }
    .blockInner{
       display: block;
       padding:16px 16px 64px;
       margin-top: 84px;
       h2{font-size: 24px;}
       h4{
         font-size: 16px;
         margin-top: 8px;
       }
    }
    .img1{
      width: 280px;
      position: absolute;
      margin-top:0px;
      top: 40px;
      right: -40px;
    }
    .img3{
      width: 150px;
    }
    .img2{width: 100%;}
    .btnWrap{
      margin-top: 20px!important;
      a{
        display: block;
        height: 32px;
      margin-top: 20px;
        button{
          float: left;
          width: 120px!important;
          height: 40px!important;
        }
      }
    }
    .ant-btn-lg{font-size: 14px;}
  }
  
}
</style>